import { OPEN_SETTING, CLOSE_SETTING } from '../actions/types'

export default function settingsReducer(state = {}, action) {
  switch (action.type) {
    case OPEN_SETTING:
      return {...state, thissetting: action.setting, editedsetting: action.setting}
    case CLOSE_SETTING:
      delete state.thissetting
      return {...state}
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/settings_reducer.js